import React from "react";
import { Form } from "react-bootstrap";
import "./Datos.component.scss";

const DatosComponent = ({ Usuario = {}, datosChange }) => {
  return (
    <Form>
      <Form.Group controlId="formNombre">
        <Form.Label>
          Nombre <span className="text-danger">*</span>
        </Form.Label>
        <Form.Control
          name="Nombre"
          type="text"
          placeholder="Nombre"
          onChange={datosChange}
          value={Usuario.Nombre}
        />
      </Form.Group>
      <Form.Group controlId="formCorreo">
        <Form.Label>
          Correo <span className="text-danger">*</span>
        </Form.Label>
        <Form.Control
          name="Usuario"
          type="email"
          placeholder="Correo"
          onChange={datosChange}
          value={Usuario.Usuario}
        />
      </Form.Group>
      <Form.Group controlId="formClave">
        <div className="row">
          <div className="col-12 col-md-6 mb-3 mb-md-0">
            <Form.Label>
              Contraseña <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              name="Clave"
              type="password"
              placeholder="Contraseña"
              onChange={datosChange}
              value={Usuario.Clave}
            />
          </div>
          <div className="col-12 col-md-6">
            <Form.Label>
              Confirmar Contraseña
              <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              name="ConfClave"
              type="password"
              placeholder="Contraseña"
              onChange={datosChange}
              value={Usuario.ConfClave}
            />
          </div>
        </div>
      </Form.Group>
    </Form>
  );
};

export default DatosComponent;
